@if (isLoaded()) {
  <div class="list-container">
    <mat-selection-list
      [hideSingleSelectionIndicator]="true"
      [multiple]="false"
      (selectionChange)="onSelection($event)">
      @for (item of data; track item) {
        <mat-list-option [value]="item.id">
          <lfw-project-list-item [project]="item" class="no-padding"></lfw-project-list-item>
        </mat-list-option>
      }
    </mat-selection-list>
    @if (!hasData()) {
      <p>{{ 'PROJECTS.NOPROJECTS' | translate }}</p>
    }
  </div>
}
@if (!isLoaded()) {
  <div>
    <div>{{ 'PROJECTS.LOADING' | translate }}</div>
  </div>
}
